export default function MissingContact() {
  return (
    <div style={{ marginBottom: 20 }}>
      <h4>Missing Contact!</h4>
    </div>
  )
}
